import { useMutation } from "@tanstack/react-query";

import { storePageActivity } from "~/api/activity";
import { Route } from "~/router";
import { errorToast } from "~/ui/admin";

export const useStoreViewPageActivity = () => {
  return useMutation({
    mutationFn: (page: Route) => storePageActivity(page),
    retry: false,
    onError: errorToast,
  });
};
